// components
import { MainNav } from './mainnav/main-nav';
import { MetaNav } from './metanav/meta-nav';

// styles
import { NavFlyoutWrapper, TransparentBackground } from './nav-flyout.styles';

// utils
import { useMegaMenuRefs, useNavOpen } from './mega-menu-provider';
import { useToggleChatWidget } from './utils/use-toggle-chat-widget';

export function NavFlyout() {
  const { isNavOpen, setIsNavOpen } = useNavOpen();
  const { navFlyoutWrapperRef } = useMegaMenuRefs();
  useToggleChatWidget();

  return (
    <>
      <TransparentBackground isNavOpen={isNavOpen} onClick={() => setIsNavOpen(false)} />
      <NavFlyoutWrapper ref={navFlyoutWrapperRef}>
        <MainNav />
        <MetaNav />
      </NavFlyoutWrapper>
    </>
  );
}
